// extracted by mini-css-extract-plugin
export default {"root":"agenda_root__yjX1R","note":"agenda_note__KHTZs"};